import styled, { css } from 'styled-components';

interface GridProps {
  $columns?: string;
  $rows?: string;
  $justifyContent?: string;
  $rowGap?: string;
  $columnGap?: string;
  $alignItems?: string;
  $padding?: string;
  $margin?: string;
  $overflow?: string;
  $width?: string;
  $top?: string;
  $bottom?: string;
  $position?: string;
  $cursor?: string;
  $minHeight?: string;
  $background?: string;
}

export const Grid = styled.div<GridProps>`
  display: grid;
  ${props => props.$columns && css`grid-template-columns: ${props.$columns};`}
  ${props => props.$rows && css`grid-template-rows: ${props.$rows};`}
  ${props => props.$justifyContent && css`justify-content: ${props.$justifyContent};`}
  row-gap: ${props=>props.$rowGap || '0px'};
  column-gap: ${props=>props.$columnGap || '0px'};
  ${props => props.$alignItems && css`align-items: ${props.$alignItems};`}
  padding: ${props=>props.$padding || '0px'};
  margin: ${props=>props.$margin || '0px'};
  ${props => props.$overflow && css`overflow: ${props.$overflow};`}
	width: ${props => props.$width || 'initial'};
	top: ${props => props.$top || 'initial'};
	bottom: ${props => props.$bottom || 'initial'};
	position: ${props => props.$position || 'initial'};
	cursor: ${props => props.$cursor || 'initial'};
	min-height: ${props => props.$minHeight || 'initial'};
	background: ${props => props.$background || 'transparent'};
`